import React, { PureComponent } from 'react'
import { Consumer } from '../Dropdown'
import { renderChildren } from '../children'

interface DropdownToggleProps {
  children?: React.ReactNode
}

export default class DropdownToggle extends PureComponent<DropdownToggleProps> {
  render() {
    const { children } = this.props

    return (
      <Consumer>
        {({ toggle, setToggleElement, show, ariaControls }) =>
          renderChildren(children, {
            onClick: toggle,
            ref: setToggleElement,
            'aria-controls': ariaControls,
            'aria-expanded': show,
          })
        }
      </Consumer>
    )
  }
}
